<template>
  <span class="BSCToast" :class="typeToast">{{ label }}</span>
</template>

<script>
'use strict'

export default {
  name: 'BSCToast',
  props: {
    type: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      timeout: null
    }
  },
  computed: {
    typeToast() {
      return [`is-${this.type}`]
    }
  }
}
</script>
